import React from 'react'
import styles from './time-input.module.scss'
import TimeInput from "react-widgets/TimeInput";

interface IProps {
  label?: string
  handleChange: any
  value: Date
  modifiers?: string
}

const TimeInputComponent = React.memo(function TimeInputComponent(props: IProps) {
 
  return (
    <div className={`${styles.inputField} ${props.modifiers ? props.modifiers : ''}`}>
      {props.label && <span className={styles.inputLabel}>{props.label}</span>}
      <TimeInput
        value={props.value}
        className={styles.timeInput}
        onChange={(value) => props.handleChange(value)}
      />
    </div>
  )
})

export default TimeInputComponent